import { configureStore } from '@reduxjs/toolkit';

import { defaultReducers, getAppStoreUtils } from './redux.ts';
import { type AppRootState } from './types.ts';

export const appStore = configureStore({
  reducer: {
    ...defaultReducers
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type { AppRootState } from './types.ts';
export const appStoreUtils = getAppStoreUtils<AppRootState>();
